import React from "react";
import Chip from "@mui/material/Chip";

export const formatString = (str) => {
    // Replace underscores with spaces
    str = (str || '').replace(/_/g, ' ');

    // Handle special characters including parentheses
    str = str.replace(/\(([^)]+)\)/g, (match, p1) => {
        // Capitalize the first letter of each word inside parentheses
        return '(' + p1.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') + ')';
    });

    // Split the string into words
    const words = str.split(' ');

    // Capitalize the first letter of the first word
    words[0] = words[0].charAt(0).toUpperCase() + words[0].slice(1);

    // Capitalize the first letter of each word after "and" or ","
    for (let i = 1; i < words.length; i++) {
        if (words[i] === 'and') {
            continue;
        }
        if (words[i - 1] === 'and' || words[i - 1] === 'of' || words[i - 1].endsWith(',') || words[i - 1].startsWith('(')) {
            words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1);
        }
    }

    // Join the words back together
    const formattedString = words.join(' ');

    return formattedString;
};

export const getMagnitude = (number) => {
    if (number === 0) return 0; // Return 0 if the number is 0

    // Find the nearest power of 10 that is less than or equal to the number
    const magnitude = Math.pow(10, Math.floor(Math.log10(number)));

    return magnitude;
};

export const convertBoolDiffValue = (value) => {
    // Check if the value is a boolean
    if (typeof value !== 'boolean') {
        throw new Error('Input must be a boolean value');
    }

    // Convert boolean to "Positive" or "Negative"
    return value ? 'Positive' : 'Negative';
}

export const createChip = (values, customUnits = {}) => {
    return (
        <React.Fragment>
            {
                Object.entries(values).map(([key, value]) => {
                    if (value > 0) {
                        const unit = customUnits[key] || '%'; // Default to '%' if no custom unit is provided
                        return (
                            <Chip key={key} label={formatString(key) + ': ' + value + unit} sx={{ mr: 1, mb: 0.5 }} />
                        )
                    }
                    return null;
                })
            }
        </React.Fragment>
    )
}

export const removeCommasFromValues = (data) => {
    if (Array.isArray(data)) {
        return data.map(item => removeCommasFromValues(item));
    } else if (typeof data === 'object' && data !== null) {
        const newObj = {};
        Object.keys(data).forEach(key => {
            if (key === 'value') {
                // If it's a string with commas, replace commas, if it's a number, keep as is
                newObj[key] = typeof data[key] === 'string' ? data[key].replace(/,/g, '') : data[key];
            } else {
                newObj[key] = removeCommasFromValues(data[key]);
            }
        });
        return newObj;
    }
    return data;
};

export const getAllOutcomes = (analysis) => {
    return Object.keys(analysis).reduce((acc, key) => {
        const items = analysis[key];
        if (Array.isArray(items)) {
            return acc.concat(items.map(item => item.title));
        }
        return acc;
    }, []);
};